export default __webpack_public_path__ + "static/media/boat_responsive.d55475bf.png";